<template>
  <div class="container article">
    <div class="contentTop">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>学长信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="create"
           @click="create()">新建</div>
    </div>
    <div class="filters card">
      <div class="content">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="学长"
                        prop="name">
            <el-input v-model="query.author_keyword"
                      placeholder="输入学长手机号/真实姓名"
                      @input="fetchList(true)"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="院校"
                        prop="name">
            <el-input v-model="query.college_keyword"
                      placeholder="请输入院校名"
                      @input="fetchList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="专业"
                        prop="name">
            <el-input v-model="query.major_keyword"
                      placeholder="请输入专业名"
                      @input="fetchList(true)"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="类型">
            <el-select v-model="query.question_id"
                       @change="fetchList(true)"
                       placeholder="请选择类型"
                       style="width: 100%;">
              <el-option v-for="(item, index) in typeList"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="精选">
            <el-select v-model="query.picked_statuses"
                       @change="fetchList(true)"
                       placeholder="请选择类型"
                       style="width: 100%;">
              <el-option v-for="(item, index) in pickedType"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布日期">
            <el-date-picker class="datetime"
                            v-model="createDatetime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                            @change="fetchList(true)">

            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <div class="tableleft">
          <!-- <div class="blue"></div> -->
          <h3 class="title">信息列表</h3>
        </div>

        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.check_statuses"
                            @change="fetchList(true)">
              <el-radio-button v-for="(item, index) in filter.type"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="result"
                border
                style="width: 100%">

        <el-table-column prop="id"
                         width="80"
                         label="ID"
                         align="center">
        </el-table-column>
        <el-table-column label="学长"
                         width="180"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.author_obj.realname }}/{{
              scope.row.author_obj.mobile
            }}</span></template>
        </el-table-column>
        <el-table-column label="院校专业"
                         width="500"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.apply_college_name }}|({{ scope.row.apply_major_code
            }}){{ scope.row.apply_major_name }}</span></template>
        </el-table-column>
        <el-table-column label="内容类型"
                         width="180"
                         prop="question_name"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.question_name }}</span></template>
        </el-table-column>
        <el-table-column prop="picked_status"
                         label="精选"
                         align="center">
          <template slot-scope="scope">
            <el-tag size="small"
                    type="warning"
                    v-if="scope.row.picked_status == 0">
              非精选
            </el-tag>
            <el-tag size="small"
                    type="success"
                    v-if="scope.row.picked_status == 1">
              精选
            </el-tag>

          </template>
        </el-table-column>
        <el-table-column prop="check_status"
                         label="状态"
                         align="center">
          <template slot-scope="scope">
            <el-tag size="small"
                    type="warning"
                    v-if="scope.row.check_status == 0">
              待审核
            </el-tag>
            <el-tag size="small"
                    type="success"
                    v-if="scope.row.check_status == 1">
              已通过
            </el-tag>
            <el-tag size="small"
                    type="danger"
                    v-if="scope.row.check_status == 2">
              已拒绝
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="点赞量"
                         prop="virtual_like_count"
                         width="90"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.virtual_like_count }}</span></template>
        </el-table-column>
        <el-table-column label="浏览量"
                         prop="pv"
                         width="90"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.pv }}</span></template>
        </el-table-column>
        <el-table-column label="上架状态"
                         align="center">
          <template slot-scope="scope">
            <el-tag size="small"
                    v-if="scope.row.status == 1">
              上架
            </el-tag>
            <el-tag size="small"
                    type="warning"
                    v-if="scope.row.status == 0">
              下架
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布日期"
                         align="center"
                         width="180"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.create_time
                ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="更新日期"
                         align="center"
                         width="180">
          <template slot-scope="scope">
            <span>{{
              $moment(scope.row.update_time).format("YYYY.MM.DD")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="300"
                         fixed="right">
          <template slot-scope="scope">
            <!-- <el-link type="primary" :underline="false" @click="goAudit(scope.row)"
              v-if="scope.row.check_status == 0"><span goDetailclass="cao">审核 |</span></el-link> -->
            <el-link type="primary"
                     :underline="false"
                     @click="undercarriage(scope.row)"
                     v-if="scope.row.check_status == 1 && scope.row.status == 1"><span class="cao">下架 |</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="grounding(scope.row)"
                     v-if="scope.row.check_status == 1 && scope.row.status == 0"><span class="cao">上架 |</span></el-link>
            <!-- <el-link type="primary"
                     :underline="false"
                     @click="goDetail(scope.row)"><span class="cao" >详情 |</span></el-link> -->
            <el-link type="primary"
                     :underline="false"
                     @click="handleToPreview(scope.row)"><span class="cao">编辑
                |</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="handleToDelete(scope.row)"><span class="cao">删除
                |</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="handleSync(scope.row)"><span class="cao">同步笔记
              </span></el-link>
            <!--     <el-link
                type="primary"
                :underline="false"
                @click="handleToClone(scope.row.id)"
              >复制</el-link> -->
            <!-- <el-link
                type="primary"
                :underline="false"
                @click="handleToOrigin(scope.row)"
                >原文链接</el-link
              > -->

          </template>
        </el-table-column>

      </el-table>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>

    <SycNote :isVisible="noteVisible"
             @close="close"
             @submit="fetchList"
             :title="title"
             :isAudit="true"
             :curr_row="currrow"
             :id_array="idArray" />

    <questionCreate :visible="createDialog"
                    :typeList="typeList"
                    @close="createDialog = false"
                    @submit="fetchList">
    </questionCreate>
    <questionEdit :visible="editDialog"
                  :typeList="typeList"
                  :row="rowEdit"
                  @close="editDialog = false"
                  @submit="fetchList">
    </questionEdit>
    <questionDetail :visible="detailDialog"
                    @close="detailDialog = false"
                    :detaiRow="detaiRow"></questionDetail>
    <questionAudit :visible="auditDialog"
                   @close="auditDialog = false"
                   :detaiRow="detaiRow"
                   @submit="fetchList">
    </questionAudit>

  </div>

</template>
<script>
import { questionList, questionRemoves, questionPut, list } from '@/api/senior'
import questionCreate from '@/components/dialog/message/questionCreate'
import questionEdit from '@/components/dialog/message/questionEdit'
import questionDetail from '@/components/dialog/message/questionDetail'
import questionAudit from '@/components/dialog/message/questionAudit'
import SycNote from '@/components/dialog/syncNote'

export default {
  components: {
    questionCreate,
    questionDetail,
    questionAudit,
    questionEdit,
    SycNote,
  },
  data() {
    return {
      idArray: [],
      title: '新建笔记',
      currrow: {},
      noteVisible: false,
      row: [],
      rowEdit: {},
      createDialog: false,
      editDialog: false,
      detailDialog: false,
      auditDialog: false,
      result: [],
      detaiRow: {},
      createDatetime: '',
      query: {
        pageIndex: 1,
        isPaging: 1,
        check_statuses: 0,
        senior_keyword: '',
        college_keyword: '',
        major_keyword: '',
        startCreateTime: '',
        endCreateTime: '',
        pageSize: 10,
        question_id: '',
      },
      pageTotal: 10,
      pickedType: [
        { label: '非精选', value: '0' },
        { label: '精选', value: '1' },
      ],
      filter: {
        type: [
          { label: '待审核', value: '0' },
          { label: '已通过', value: '1' },
          { label: '已拒绝', value: '2' },
        ],
      },
      typeList: [
        {
          value: '',
          label: '',
        },
      ],
    }
  },
  created() {
    this.fetchList()
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startCreateTime = this.$moment(value[0]).valueOf()
        this.query.endCreateTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startCreateTime = ''
        this.query.endCreateTime = ''
      }
    },
  },
  methods: {
    create() {
      this.createDialog = true
      this.fetchList()
    },
    unmount(data) {
      questionPut(data).then((res) => {
        this.fetchList()
      })
    },
    grounding(item) {
      let data = {
        id: item.id,
        status: 1,
      }
      this.unmount(data)
    },
    undercarriage(item) {
      let data = {
        id: item.id,
        status: 0,
      }
      this.unmount(data)
    },
    handleSync(item) {
      this.idArray = this.result.map((item) => item.id)
      ;(this.currrow = item), (this.noteVisible = true)
    },
    close() {
      this.noteVisible = false
      // this.$emit('refurse')
    },
    mounted() {},
    fetchList() {
      // if (this.result.length == 0) {
      //   this.query.check_statuses = 1
      // }
      questionList(this.query).then((res) => {
        this.result = res.list
        // let arr = res.list
        this.pageTotal = res.count
        //  获取类型
        list({ isPaging: 0 }).then((res) => {
          res.list.map((item) => {
            this.typeList.push({
              value: item.id,
              label: item.question_name,
            })
          })
          this.typeList = Array.from(
            new Set(this.typeList.map((item) => JSON.stringify(item)))
          ).map((item) => JSON.parse(item))
          // let dlist = []
          // res.list.forEach((titem, tindex) => {
          //   arr.forEach((item, index) => {
          //     if (item.question_name == titem.question_name) {
          //       item.question_title = titem.question_title
          //       dlist.push(item)

          //     }
          //   })

          // });
          // console.log('处理后数据', dlist)
          // this.result = dlist
        })
      })
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 审核上下架
    goAudit(row) {
      this.auditDialog = true
      this.detaiRow = row
    },
    // 详情
    goDetail(row) {
      this.detaiRow = row
      this.detailDialog = true
    },
    // 编辑
    handleToPreview(row) {
      this.rowEdit = row

      this.editDialog = true
    },
    // 删除
    handleToDelete(row) {
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        questionRemoves({ id: row.id }).then((res) => {
          this.fetchList(true)
        })
      })
    },
  },
}
</script>
<style scoped lang="less">
.cao {
  display: inline-block;
  // width: 35px;
}

.article {
  .contentTop {
    display: flex;
    justify-content: space-between;

    .breadcrumb {
      margin-bottom: 30px;
    }

    .create {
      cursor: pointer;
      font-size: 14px;
      color: #ffff;
      width: 46px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
  }

  .card {
    margin-top: 5px;
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }

    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }

    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .values {
      display: flex;
      flex-wrap: wrap;
      flex: 1;

      .table-header {
        border: 1px solid red;
        display: flex;

        justify-content: space-between;
        width: 101%;
        height: 40px;

        .title {
          border: 1px solid red;
          font-size: 20px;
        }

        .blue {
          margin-right: 10px;
          width: 4px;
          height: 20px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
      }
    }

    .value-item {
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      padding: 0 10px;
      margin-right: 5px;
      cursor: pointer;

      &.active {
        color: #fff;
        background: #409eff;
      }
    }
  }

  .results {
    margin-top: 10px;
    padding-right: 32px;

    .table-header {
      display: flex;
      justify-content: space-between;

      .tableleft {
        display: flex;

        .blue {
          width: 4px;
          height: 20px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }

        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }

    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }

    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }

    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }

    .el-link {
      margin: 0 8px;
    }

    .item-table-column {
      text-align: left;
    }
  }
}
</style>
